
// Define the color palette for charts
export const CHART_COLORS = [
  '#8B5CF6', // Vivid Purple 
  '#F97316', // Bright Orange
  '#0EA5E9', // Ocean Blue
  '#EA384C', // Red
  '#00C49F', // Teal
  '#D946EF', // Magenta Pink
  '#FFBB28', // Yellow
  '#1EAEDB', // Light Blue
  '#7E69AB', // Lavender
  '#A4DE6C', // Light Green
  '#6E59A5', // Dark Purple
  '#FF8042', // Coral
  '#33C3F0', // Sky Blue
  '#D6BCFA', // Pale Purple
  '#FCBBA1', // Peach
  '#E5DEFF', // Very Pale Purple
  '#C5E1A5', // Pale Green
  '#81D4FA', // Pale Blue
  '#FFD54F'  // Amber
];

// Format numbers with commas for thousands
export const formatNumberWithCommas = (value: number) => {
  return value.toLocaleString('en-US');
};

// Prepare data for charts based on buckets or subcategories
export const prepareBudgetChartData = (items: any[], colorPalette: string[] = CHART_COLORS) => {
  return items.map((item, index) => ({
    name: item.name,
    value: item.budget,
    color: colorPalette[index % colorPalette.length]
  }));
};
